import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@app/features/auth/auth.service';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { UrlRedirectService } from '../services/url-redirect.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly urlRedirectService = inject(UrlRedirectService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.urlRedirectService.redirectUrl.set(state.url);
    return this.authService.initialized$.pipe(
      filter(Boolean),
      switchMap(() => this.authService.authInfo$),
      map((auth) => {
        if (auth.isLoggedIn()) {
          return true;
        }
        return this.router.createUrlTree(['/login']);
      }),
    );
  }
}
